import React, { useState, useRef } from 'react'
import { DB_ACTIONABLES_TABS, handleValidateCodevalue } from '../../Utility/constant';
import { Box, Button, Tab, Tooltip } from '@mui/material';
import { TabContext, TabList } from '@mui/lab';
import { useSelector } from 'react-redux';
import PersistentTabPanel from '../../Components/PersistentTabPanel';
import LeadAccordion from '../../Components/LeadAccordion';
import TaskActionables from './TaskActionables';
import LeadActionables from './LeadActionable';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RefreshIcon from '@mui/icons-material/Refresh';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { useIsMobile } from '../../Utility/hooks/useIsMobile';
import './Dashboard.css';
import BiztantuLoader from '../../Components/Loader';

const Actionables = () => {
  
      const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const [selectedTab, setSelectedTab] = React.useState(specificRolePermission?.isTaskView ? 
        DB_ACTIONABLES_TABS?.DB_ACTIONABLES_TAB_TASKS : DB_ACTIONABLES_TABS?.DB_ACTIONABLES_TAB_LEADS);
        const handleChange = (event, newValue) => {
            setSelectedTab(newValue);
        };

        const taskRefetchRef = useRef(null);
        const leadRefetchRef = useRef(null);

        const handleRegisterTaskRefetch = (fn) => { taskRefetchRef.current = fn; };
        const handleRegisterLeadRefetch = (fn) => { leadRefetchRef.current = fn; };

        const handleRefresh = () => {
            if (selectedTab === DB_ACTIONABLES_TABS?.DB_ACTIONABLES_TAB_TASKS) {
                taskRefetchRef.current?.();
            } else {
                leadRefetchRef.current?.();
            }
        };
        const isMobile = useIsMobile();

        const tabs = [
        {
            value: "DB_ACTIONABLES_TAB_TASKS",
            label: handleValidateCodevalue(internationalise, "DB_ACTIONABLES_TAB_TASKS"),
            icon: <AssignmentIcon />,
            permission : specificRolePermission?.isTaskView,
        },
        {
            value: "DB_ACTIONABLES_TAB_LEADS",
            label: handleValidateCodevalue(internationalise, "DB_ACTIONABLES_TAB_LEADS"),
            icon: <PeopleAltOutlinedIcon/>,
            permission : specificRolePermission?.isLeadView,
        },
        ];const visibleTabs = tabs.filter(tab => tab.permission);
        return (
            <React.Fragment>
                <LeadAccordion className="actionables-accordion-fullwidth"
                        label={handleValidateCodevalue(internationalise,'DB_TODOS')}
                        defaultOpen = {true}
                      >
                <Box className="actionables-tab-context-container">
                    <TabContext value={selectedTab}>
                   <Box className="actionables-tabs-header-bar">
                        <TabList
                        onChange={handleChange}
                        variant="scrollable"
                        allowScrollButtonsMobile
                        >
                        {visibleTabs.map((tab) => (
                            <Tab
                            key={tab.value}
                            value={tab.value}
                            icon={
                                isMobile ? (
                                <Tooltip title={tab.label}>{tab.icon}</Tooltip>
                                ) : (
                                tab.icon
                                )
                            }
                            iconPosition="start"
                            label={isMobile ? null : tab.label}
                            className={`actionables-tab-item ${isMobile ? "actionables-tab-item--mobile" : ""}`}
                            />
                        ))}
                        </TabList>
                        <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_REFRESH")}>
                            <Button
                                className={`${isMobile ? "biztantu-sec-btn-mobile" : "biztantu-sec-btn"} actionables-refresh-button`}
                                variant="outlined"
                                onClick={handleRefresh}
                            >
                                <RefreshIcon fontSize="small" />
                            </Button>
                        </Tooltip>
                    </Box>
                    <BiztantuLoader isChildren={true} open = {isLoadingProgress}>
                    <PersistentTabPanel value={selectedTab} index={DB_ACTIONABLES_TABS?.DB_ACTIONABLES_TAB_TASKS}>
                        <TaskActionables
                            onRegisterRefetch={handleRegisterTaskRefetch}
                            isActive={selectedTab === DB_ACTIONABLES_TABS?.DB_ACTIONABLES_TAB_TASKS}
                        />
                    </PersistentTabPanel>
                    <PersistentTabPanel value={selectedTab} index={DB_ACTIONABLES_TABS?.DB_ACTIONABLES_TAB_LEADS}>
                        <LeadActionables
                            onRegisterRefetch={handleRegisterLeadRefetch}
                            isActive={selectedTab === DB_ACTIONABLES_TABS?.DB_ACTIONABLES_TAB_LEADS}
                        />
                    </PersistentTabPanel>
                    </BiztantuLoader>
                        
                    </TabContext>
                </Box>
                </LeadAccordion>
            </React.Fragment>
        )
    }
    
export default Actionables